<div class="manufacturer-container" *ngIf="!isLoadingLabels && !isLoadingManufacturers">
	<div class="search" *ngIf="customInterface.id == undefined">
		<cpi-msp-table
			[header]="searchHeader"
			[body]="manufacturerList"
			[searchable]="true"
			[height]="'55dvh'"
			[itemPadding]="'1%'"
			[labels]="labels"
			[insideSort]="true"
			(getSelectedItem)="$event[0]['version'] === 'Manualmente' ? openForm($event[0]) : null; getReportManufacturer($event[0]['id'])">
		</cpi-msp-table>

		<div class="button-container">
			<div class="button" (click)="clearInputs(true)">{{ labels.lbl_gerar_novo_fabricante }}</div>
		</div>
	</div>

	<ng-container *ngIf="customInterface.id != undefined || customInterface.id === ''">
		<div class="header-wrap">
			<span class="tab" [ngClass]="{ selected: selectedTab === 'manufacturer' }" (click)="selectedTab = 'manufacturer'">{{
				labels.lbl_asset_fabricante
			}}</span>
			<span
				class="tab"
				[ngClass]="{ selected: selectedTab === 'logs' }"
				(click)="selectedTab = 'logs'"
				*ngIf="!isReportVisible && filteredReport.length > 0"
				>Logs</span
			>
		</div>
		<div class="body-wrap">
			<ng-container *ngIf="selectedTab === 'manufacturer'">
				<div class="search-container">
					<!-- <div class="dotted-input-container">
            <span>{{labels.lbl_geral_pesquisar}}</span>
            <input type="text" [value]="searchText" [placeholder]="labels.lbl_geral_pesquisar" (input)="searchText = $event.target.value; searchItems()">
          </div>
  
          <div class="table-container">
            <table>
              <thead>
                <tr>
                  <th (click)="selectAll()"><fa-icon [icon]="allSelected === true ? icons.faCheckSquare : icons.faSquare"></fa-icon></th>
                  <th>{{labels.lbl_asset_fabricante}}</th>
                  <th>{{labels.lbl_geral_versao}}</th>
                  <th>{{labels.lbl_geral_ativo}}</th>
                  <th>{{labels.lbl_bulletin_actions}}</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="filteredItems.length > 0; else showAll">
                  <tr class="select-bond" *ngFor="let item of filteredItems; let indexItem = index">
                    <td><fa-icon *ngIf="item.version == 'Manualmente'" [icon]="item.isChecked === true ? icons.faCheckSquare : icons.faSquare" (click)="selectMultiple(item, indexItem)"></fa-icon></td>
                    <td>{{ item.manufacturer }}</td>
                    <td>{{ item.version }}</td>
                    <td>{{ item.active ? labels.lbl_geral_ativo : labels.lbl_geral_desativado }}</td>
                    <td><fa-icon [icon]="item.version == 'Manualmente' ? icons.faPencil : icons.faLock" (click)="item.version === 'Manualmente' ? openForm(item) : null; getReportManufacturer(item.id)"></fa-icon></td>
                  </tr>
                </ng-container>
                <ng-template #showAll>
                  <tr class="select-bond" *ngFor="let item of manufacturerList; let indexItem = index">
                    <td><fa-icon *ngIf="item.version == 'Manualmente'" [icon]="item.isChecked === true ? icons.faCheckSquare : icons.faSquare" (click)="selectMultiple(item, indexItem)"></fa-icon></td>
                    <td>{{ item.manufacturer }}</td>
                    <td>{{ item.version }}</td>
                    <td>{{ item.active ? labels.lbl_geral_ativo : labels.lbl_geral_desativado }}</td>
                    <td><fa-icon [icon]="item.version == 'Manualmente' ? icons.faPencil : icons.faLock" (click)="item.version === 'Manualmente' ? openForm(item) : null; getReportManufacturer(item.id)"></fa-icon></td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div> -->

					<div class="form-container" *ngIf="showForm">
						<div class="dotted-input-container">
							<span>{{ labels.lbl_asset_fabricante }} *</span>
							<input id="manufacturer" name="manufacturer" type="text" [(ngModel)]="customInterface.manufacturer" />
						</div>

						<div class="dotted-input-container">
							<span>{{ labels.lbl_geral_motivo }}</span>
							<textarea
								class="textarea"
								[rows]="3"
								[value]="customInterface.message"
								(input)="customInterface.message = $event.target.value"
								>{{ customInterface.message }}</textarea
							>
						</div>

						<div class="button-container">
							<div class="button" (click)="clearInputs(false)">{{ labels.lbl_geral_voltar }}</div>
							<div
								class="button"
								*ngIf="customInterface.active === 1"
								(click)="desactiveSelectedManufacturers($event)"
								#unbondAllCiButton>
								{{
									unbondAllCiButton.classList.contains('double-click')
										? labels.lbl_geral_confirmar
										: labels.lbl_geral_desativar
								}}
							</div>
							<div
								class="button"
								*ngIf="customInterface.active === 0"
								(click)="activeSelectedManufacturers($event)"
								#unbondAllCiButton>
								{{
									unbondAllCiButton.classList.contains('double-click')
										? labels.lbl_geral_confirmar
										: labels.lbl_geral_location_ativar
								}}
							</div>
							<div class="button" type="submit" (click)="validateForm()">{{ labels.lbl_geral_salvar }}</div>
						</div>
					</div>
				</div>

				<div class="search-container" *ngIf="showAlterForm">
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_motivo }} *</span>
						<textarea
							class="textarea"
							[rows]="3"
							[value]="customInterface.message"
							(input)="customInterface.message = $event.target.value"
							>{{ customInterface.message }}</textarea
						>
					</div>

					<div class="button-container">
						<div class="button" (click)="activeSelectedManufacturers($event)" #activateButton>
							{{
								activateButton.classList.contains('double-click')
									? labels.lbl_geral_confirmar
									: labels.lbl_geral_location_ativar
							}}
						</div>
						<div class="button" (click)="desactiveSelectedManufacturers($event)" #deactivateButton>
							{{
								deactivateButton.classList.contains('double-click')
									? labels.lbl_geral_confirmar
									: labels.lbl_geral_desativar
							}}
						</div>
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="selectedTab === 'logs'">
				<div class="input">
					<!-- <div class="dotted-input-container">
            <span>{{ labels.lbl_geral_pesquisar }}</span>
            <input type="text" [(ngModel)]="searchTextReport" [placeholder]="labels.lbl_geral_pesquisar" (keyup)="searchReport()"/>
          </div> -->

					<div class="table-container">
						<table>
							<thead>
								<tr>
									<th>{{ labels.lbl_geral_data }}</th>
									<th>{{ labels.lbl_analista }}</th>
									<!-- <th>{{ labels.lbl_asset_fabricante }}</th> -->
									<th>{{ labels.lbl_geral_motivo }}</th>
								</tr>
							</thead>

							<tbody>
								<ng-container *ngIf="filteredReport || filteredReport?.length === 0; else showAll">
									<tr class="select-bond" *ngFor="let item of filteredReport; let indexItem = index">
										<td>{{ item.date_time }}</td>
										<td>{{ item.full_name }}</td>
										<!-- <td>{{ item.manufacturer }}</td> -->
										<td>{{ item.message }}</td>
									</tr>
								</ng-container>

								<ng-template #showAll>
									<tr class="select-bond" *ngFor="let item of reportManufacturerList; let indexItem = index">
										<td>{{ item.date_time }}</td>
										<td>{{ item.full_name }}</td>
										<!-- <td>{{ item.manufacturer }}</td> -->
										<td>{{ item.message }}</td>
									</tr>
								</ng-template>
							</tbody>
						</table>
					</div>
				</div>
			</ng-container>
		</div>
	</ng-container>
</div>

<cpi-dot-bounce-loading-effect
	class="mt-2 ml-2"
	*ngIf="isLoadingLabels || isLoadingManufacturers"
	[color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
